import React, { useEffect, useState } from "react";
import { Box, Grid, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useFetchSystemById from "../../hooks/useFetchSystemById";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import { IconBtnEditBase } from "../../common/utils/icons";
import Loader from "../../components/Molecules/Loader/Loader";
import { useAuth } from "../../contexts/AuthContext";
import { useAppTranslation } from "../../hooks/useAppTranslation";

const ViewSystem: React.FC = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { t } = useAppTranslation();
  const { id: systemId } = useParams();

  // Permission checks for system actions
  const canEditSystem = hasPermission("system", "edit");
  const [formData, setFormData] = useState<any>({
    value: "",
    is_active: true,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Fetch system data
  const [systemData] = useFetchSystemById({
    setIsLoading,
    currentSystemId: systemId,
  });

  useEffect(() => {
    if (systemData) {
      setFormData({
        value: systemData?.value,
        is_active: systemData?.is_active,
      });
      setCurrentBreadcrumbPage({
        name: systemData?.value,
        id: systemData?.id,
      });
    }
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [systemData, setCurrentBreadcrumbPage]);

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box>
        <Box className="text-box-card-white">
          <Box className="text-box-header">
            <h3>{t("systems.view.header")}</h3>
            {canEditSystem && (
              <button
                className="btn-nostyle icon-btn-edit"
                onClick={() => navigate(`/system/edit/${systemId}`)}
              >
                <IconBtnEditBase
                  width={32}
                  height={32}
                  ariaLabel={t("systems.view.ariaEdit")}
                />
              </button>
            )}
          </Box>

          <Grid container rowSpacing={1.5} columnSpacing={2.5}>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <label className="label-text">
                {t("systems.view.label.systemName")}
              </label>
              <TextField
                type="text"
                name="value"
                value={formData?.value || ""}
                className="form-control read-only"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <label className="label-text">
                {t("systems.view.label.status")}
              </label>
              <TextField
                type="text"
                name="is_active"
                value={
                  formData?.is_active
                    ? t("common.status.active")
                    : t("common.status.inactive")
                }
                className="form-control read-only"
                disabled
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ViewSystem;
